<template>
  <v-app>
    <!--INDICA LA PÁGINA EN LA QUE SE ENCUETRA-->
    <v-card class="grlCardInfo">
      <v-breadcrumbs :items="obtRuta" class="grlClase">
        <template v-slot:item="{ item }">
          <v-breadcrumbs-item @click="insertarRuta(item.ruta)" :disabled="item.disabled">
            {{ item.text.toUpperCase() }}
          </v-breadcrumbs-item>
        </template>
      </v-breadcrumbs>
    </v-card>
    <!--IMAGEN Y TITULO DE LA PÁGINA-->
    <v-card>
      <v-img :src="imgTitle" class="grlCardImg">
        <div class="grlCardInfo">
          <h1 class="my-auto hidden-sm-and-down">Proceso de admision</h1>
        </div>
      </v-img>
    </v-card>
    <!---->
    <div class="gralMargenes" id="gralEspaciado">
      <hr>
      <v-row>
        <v-col class="admiColInfo">
          <v-card elevation="10" class="p-5 mt-5">
            <h3>Documentos</h3>
            <v-timeline align-top dense>
              <v-timeline-item fill-dot icon="mdi-text-box-check-outline">
                <div>
                  <v-btn text color="red" class="btnAdmision" v-bind:href="`../pdfs/Carta Compromiso.pdf`"
                    target="_blank">
                    CARTA COMPROMISO
                  </v-btn>
                </div>
              </v-timeline-item>
              <v-timeline-item fill-dot icon="mdi-notebook-edit">
                <div>
                  <v-btn text color="red" class="btnAdmision" v-bind:href="`../pdfs/Datos Personales.pdf`"
                    target="_blank">
                    HOJA DE DATOS PERSONALES
                  </v-btn>
                </div>
              </v-timeline-item>
            </v-timeline>
            </v-card>
          <v-card elevation="10" class="p-5 mt-5">
            <h3>Contactanos</h3>
            <div>
              <v-icon color="red">mdi-phone</v-icon> (871) 785 51 70
            </div>
          </v-card>
        </v-col>
        <v-col class="my-auto">
          <v-card elevation="10">
            <v-img contain :src="img" alt=" Requisitos de ingreso" width="650" height="auto" class="mx-auto" />
          </v-card>
        </v-col>
      </v-row>
    </div>
  </v-app>
</template>
<script>

export default {
  data: () => ({
    img: require('../../assets/img/cartel2025.jpg'),
    imgTitle: require('../../assets/img/banner-OE.jpg'),
    obtRuta: [
      {
        text: 'Inicio',
        disabled: false,
        ruta: '/',
      },
      {
        text: 'Aspirantes',
        disabled: true,
        ruta: '/',
      },
      {
        text: 'Proceso de Admision',
        disabled: true,
        ruta: '/',
      },
    ],
  }),
  methods: {
    insertarRuta(ruta) {
      this.$router.push(ruta);
    },
  },
};
</script>
